import { defineStyleConfig } from "@chakra-ui/react"

export const headingTheme = defineStyleConfig({
  variants: {
    subtitle: props => {
      return { color: props.colorMode === "light" ? "gray.600" : "gray.400" }
    },
  },
})
